// Artwork Editor — queue-index route.
// -----------------------------------------------------------------
// Per docs/architecture/m3-spa-scaffold-plan.md § 3 M3.4 + dispatch
// docs/architecture/dispatches/m3-4-prod-cutover.md § 3.5 + § 6.1
// AND
// docs/architecture/dispatches/m6-1-mutations.md § 1.1 (1 new queue-
// index page) + § 4.4 contract.
//
// M6.0: read-only placeholder body pointing operators at direct-URL
// navigation.
// M6.1 (this file): mount `<ArtworkQueueIndex>` when the flag is on
// AND no `arkId` is present in the path. Operators can browse the
// staging queue, filter by status, and click through to an artwork
// editor.
//
// Gated behind `VITE_FF_ARTWORK_EDITOR`. Off by default in both
// `.env.staging` and `.env.production` historically; M6.0-L1 flipped
// staging to `on`. Production stays off through M6.3-L2.

import { Navigate, createFileRoute } from '@tanstack/react-router';

import { ArtworkQueueIndex } from '@/components/artwork-editor/ArtworkQueueIndex';
import { isFeatureEnabled } from '@/lib/featureFlags';

type ArtworkEditorIndexSearch = {
  staging_filter?: string;
};

const ArtworkEditorRoute = () => {
  const search = Route.useSearch();
  if (!isFeatureEnabled('ARTWORK_EDITOR')) {
    return <Navigate to='/hello' replace />;
  }
  const initialFilter =
    typeof search.staging_filter === 'string' && search.staging_filter.trim()
      ? search.staging_filter.trim()
      : undefined;
  return (
    <ArtworkQueueIndex
      mode='staging'
      {...(initialFilter !== undefined ? { initialFilter } : {})}
    />
  );
};

export const Route = createFileRoute('/_authenticated/artwork-editor')({
  component: ArtworkEditorRoute,
  validateSearch: (s: Record<string, unknown>): ArtworkEditorIndexSearch => {
    const result: ArtworkEditorIndexSearch = {};
    if (typeof s.staging_filter === 'string') {
      result.staging_filter = s.staging_filter;
    }
    return result;
  },
});
